<template>
  <div class="yk-custom-datetimerange-container">
    <div class="wrap" style="display: flex">
      <div class="type" style="display: flex">
        <div :class="{ item: true, active: activeTimeType === 0 }" @click="activeTimeType = 0">今天</div>
        <div :class="{ item: true, active: activeTimeType === 1 }" @click="activeTimeType = 1">近7天</div>
        <div :class="{ item: true, active: activeTimeType === 2 }" @click="activeTimeType = 2">近30天</div>
      </div>
      <el-date-picker
        v-model="dateTimeRange"
        :picker-options="pickerOptions"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="defaultTime"
        :clearable="false"
        @change="changeTime"
        align="right"
        size="small"
      >
      </el-date-picker>
    </div>
  </div>
</template>
<script>
import {
  getTodayStartTimestamp, getTodayEndTimestamp, getSevenTimestamp, getThirtyTimestamp, getTodayEndTimestampLast,
} from "@/utils/index";

export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      defaultTime: [],
      dateTimeRange: [],
      activeTimeType: this.type,
      pickerOptions: {
        disabledDate(time) {
          // 日期只能选择100天前到今天的日期
          const curDate = new Date().getTime();
          const three = 100 * 24 * 3600 * 1000;
          const threeMonths = curDate - three;
          return time.getTime() > getTodayEndTimestampLast() || time.getTime() < threeMonths;
        },
      },
    };
  },
  watch: {
    type(newType) {
      this.changeDateTimeRange(newType);
    },
    dateTimeRange(newV) {
      let selectedDateArr = [];
      if (!newV) {
        selectedDateArr = [];
      } else {
        selectedDateArr = newV;
      }
      // // 默认现在的小时分秒
      // const nowDate = new Date();
      // const hour = this.formatNumber(nowDate.getHours());
      // const minute = this.formatNumber(nowDate.getMinutes());
      // const second = this.formatNumber(nowDate.getSeconds());
      // this.defaultTime[1] = `${hour}:${minute}:${second}`;
      this.defaultTime[1] = `23:59:59`;

      // const date = new Date().getTime();
      // 日期是否包含今天
      // if (formatDate(date) === formatDate(selectedDateArr[1])) {
      //   this.defaultTime[1] = `${hour}:${minute}:${second}`;
      // } else {
      //   this.defaultTime[1] = "23:59:59";
      // }

      this.$emit("change", selectedDateArr);
    },
    activeTimeType(type) {
      this.changeDateTimeRange(type);
      // 需要在change事件之后执行
      this.$nextTick(() => {
        this.$emit("typeChange");
      });
    },
  },
  methods: {
    // 将时间戳转换成时间格式化
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },
    changeDateTimeRange(type) {
      if (type === 0) {
        this.dateTimeRange = [getTodayStartTimestamp(), getTodayEndTimestampLast()];
      } else if (type === 1) {
        this.dateTimeRange = [getSevenTimestamp(), getTodayEndTimestampLast()];
      } else if (type === 2) {
        this.dateTimeRange = [getThirtyTimestamp(), getTodayEndTimestampLast()];
      }
    },
    changeTime() {
      this.activeTimeType = -1;
    },
  },
  created() {
    this.changeDateTimeRange(0);
  },
};
</script>
<style lang="scss">
.yk-custom-datetimerange-container {
  > .wrap {
    > .type {
      .item {
        width: 100px;
        min-width: 100px;
        margin-right: 14px;
        flex: 1;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        border: 1px solid #DDE0E7;
        color: #5E5E63;
        &.active {
          border: 1px solid #008CFF;
          color: #008CFF;
        }
      }
    }
  }
}
</style>
